import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createEventContactRemindersSchemas } from 'shared/db/validation/schema/eventContactReminders';
import { Validator } from 'shared/db/validation/validator';
import {
    EventContactReminderRawRecord,
    EventContactReminderUpdateRawRecord,
} from 'shared/types/EventContactReminder';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { EventContactReminderDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const addValidator = createDBEntityValidator<EventContactReminderRawRecord>(
    createEventContactRemindersSchemas().add,
);
const updateValidator =
    createDBEntityValidator<EventContactReminderUpdateRawRecord>(
        createEventContactRemindersSchemas().update,
    );
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    createEventContactRemindersSchemas().delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-event-contact-reminders'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createEventContactRemindersInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const eventContactRemindersInputValidation: EventContactReminderDBValidation =
    {
        add: createEventContactRemindersInputValidation(
            addValidator,
            validationStrategy,
        ),
        update: createEventContactRemindersInputValidation(
            updateValidator,
            validationStrategy,
        ),
        delete: createEventContactRemindersInputValidation(
            deleteValidator,
            validationStrategy,
        ),
    };
